import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "The gym has transformed my life! With supportive trainers and top-notch equipment, I've surpassed my fitness goals and gained newfound confidence.",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'I never thought I would enjoy working out until I joined this gym. The friendly atmosphere and variety of classes keep me motivated, and I have never felt better!',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:'Joining this gym was the best decision I have made for my health. The personalized workouts and positive environment make me excited to come back every day!',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
